export const FEATURE_ADMIN_AREA = 'REACT_APP_FEATURE_ADMIN_AREA';

export function isEnabled(featureKey: string): boolean {
  try {
    if (typeof process.env[featureKey] !== 'undefined') {
      return !!JSON.parse(process.env[featureKey]!);
    }
  } catch (e) {
    console.error(e);
  }
  return false;
}
